import { Tabs } from 'antd';
import React from 'react';
import CurrentNotificationList from './CurrentNotificationList';


export default function NoticeTabLayout() {
    return (
        <div className="container notice-list">
            <div className="row justify-content-center">
                <Tabs
                    defaultActiveKey="1"
                    items={[
                        {
                            label: (
                                <span>
                                    <i className="fa-solid fa-rss"></i>
                                    &nbsp;New Messages
                                </span>
                            ),
                            key: "1",
                            className: "notification-list",
                            children: <CurrentNotificationList />,
                        },
                        // {
                        //     label: (
                        //         <span>
                        //             <i className="fa-solid fa-clock-rotate-left"></i>
                        //             &nbsp;Read Messages
                        //         </span>
                        //     ),
                        //     key: "2",
                        //     children: <PastNotificationList />,
                        // },
                    ]}
                />
            </div>
        </div>
    )

};
